import { api, IpInfoApi } from '../axios';
import Mongo from './Mongo';

import { IpInfoType, SessionEveResponse } from '../../types';

import Authentication from './Authentication';
import { AxiosResponse } from 'axios';
const SESSION_ENDPOINT = '/service/session';
class Session extends Mongo {
  public async getIp() {
    const response = await IpInfoApi.get<IpInfoType>('', {
      params: {
        token: '7038ef95f98cee',
      },
    });
    return response;
  }
  public async getSession({ where = {}, max = 1, sort = '', page = 1 }) {
    try {
      const loginData = Authentication.loggedUser();
      if (!loginData) return;
      const flattenQuery = this.flattenMongoQuery({
        query: { ...where, user_email: loginData.user.email },
      }) as unknown;
      const response: AxiosResponse<SessionEveResponse> = await api.get(
        SESSION_ENDPOINT,
        {
          params: {
            page,
            sort,
            max_results: max,
            where: flattenQuery,
          },
        }
      );
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  public async saveSession() {
    try {
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      const { data } = await this.getIp();
      const loginData = Authentication.loggedUser();
      if (!loginData) return;
      await api.post(SESSION_ENDPOINT, {
        user_email: loginData.user.email,
        area: loginData.area.name,
        location: {
          ip: data.ip,
          loc: {
            type: 'Point',
            coordinates: data.loc.split(',').map(parseFloat).reverse()
          },
          country: data.country,
          region: data.region,
          city: data.city,
        },
        device: {
          desktop: isMobile ? false : true,
        },
      });
    } catch (error) {
      console.error(error);
    }
  }
}

export default new Session();
